



























































































































import IListStatusTransformation from '@/store/models/IListStatusTransformation';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Snackbar from '@/components/shared/Snackbar.vue';
import IRolePermission from '@/store/models/IRolePermission';

@Component({
    components: {
        Snackbar
    }
})
export default class ListStatusTransformationSelector extends Vue {
    searchListStatusTransformation: string = "";
    dialog: boolean = false;
    isValid: boolean = true;
    sortBy: string = 'name';
    sortDesc: boolean = false;
    headers: any = [
        { text: 'Name', value: 'name' },
        { text: 'Actions', value: 'actions', sortable: false }
    ];
    editedIndex : number = -1;
    editedItem : IListStatusTransformation = {
        id: "",
        name: "",
        idCompany: ""
    }
    defaultItem : IListStatusTransformation = {
        id: "",
        name: "",
        idCompany: ""
    }

    @Prop({ type: Array, required: true })
    ListStatusTransformationList !: IListStatusTransformation[];
    @Prop({ type: Array, required: true })
    Permissions !: IRolePermission[];

    selectedListStatusTransformation : IListStatusTransformation[] = [];

    get formTitle() { return this.editedIndex === -1 ? 'New Transformation Status ' : 'Edit Transformation Status'; }

    @Watch('dialog')
    onDialogChanged(val: any) {
        val || this.close();
    }

    resetListStatusTransformation() {
        this.selectedListStatusTransformation = [];
    }

    editListStatusTransformation (item: any, dbox = true) {
        this.editedIndex = this.ListStatusTransformationList.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.dialog = true;
    }

    saveListStatusTransformation () {
        if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
            if (this.editedIndex > -1 || this.selectedListStatusTransformation[0]) {
                this.close();
                this.$emit('editListStatusTransformation', this.editedItem);
                Object.assign(this.ListStatusTransformationList[this.editedIndex], this.editedItem);
            } else {
                this.selectedListStatusTransformation[0] = this.editedItem;
                this.$emit('saveListStatusTransformation', this.editedItem);
            }
            this.close();
        } else {
            this.$emit('showMessageWarning', 'All required fields must be filled out');
        }
    }

    deleteListStatusTransformation (statusTransformation: IListStatusTransformation) {
        this.$emit('deleteListStatusTransformation', statusTransformation);
        this.close();
    }

    close() : void {
        this.dialog = false;
        this.$nextTick(() => {
            this.editedItem = Object.assign({}, this.defaultItem);
            this.editedIndex = -1;
        });
    }

    selectListStatusTransformation(item : any) : void {
        if (!this.selectedListStatusTransformation.includes(item)) {
            this.selectedListStatusTransformation = [];
            this.selectedListStatusTransformation = [item];
        } else {
            this.selectedListStatusTransformation = [];
        }
    }
    
    showMessageInfo(message: string) {
        (this.$refs.snackbar as Snackbar).showInfo(message);
    }

    showMessageError(message: string) {
        (this.$refs.snackbar as Snackbar).showError(message);
    }
    
    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }
}
